import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { PERMISSIONS_TYPES_TRANSLATIONS } from '@gem/call/constants';
import { useTranslation } from '@gem/modules/i18n';
import { Button } from '@gem/ui-kit';

import { PermissionRequestItem } from '../PermissionRequestItem/PermissionRequestItem';
import { useRequestsPermissionsBlockPresenter } from './RequestsPermissionsBlock.presenter';
import styles from './RequestsPermissionsBlock.styles.m.css';
import { IRequestsPermissionsBlockProps } from './RequestsPermissionsBlock.types';

export const RequestsPermissionsBlock: FC<IRequestsPermissionsBlockProps> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useRequestsPermissionsBlockPresenter(props);

  return (
    <>
      <div className={styles.titleHeader}>
        <div className={styles.title}>
          {t(PERMISSIONS_TYPES_TRANSLATIONS[props.permissionType])}
        </div>
        <Button
          onClick={presenter.approveAll}
          theme="fixed-color"
          className={styles.declineButton}
          size={'0'}
        >
          {t('call_permissions_approve_all')}
        </Button>
      </div>
      {presenter.permissionsRequests?.map((userId) => (
        <PermissionRequestItem
          key={userId}
          permissionType={props.permissionType}
          call={props.call}
          callController={props.callController}
          userId={userId}
        />
      ))}
    </>
  );
});
